module.exports = __webpack_public_path__ + "static/media/search classwise.603d00cf.svg";